import { useRepairOrderQuotesStore } from '../../../repair-order-quotes-context';
import styles from './styles.module.scss';
import { usePartInfo } from './use-part-info';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { usePartsAvailabilityMutation } from 'features/vhc/api/use-parts-availability.mutation';
import { RepairOrderQuoteItems } from 'features/vhc/pages/record/form-state';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { formatCurrencySafe } from 'utils/formats';

type Props = {
  mainIndex: number;
  rowIndex: number;
  isShow: boolean;
};
export const AvailabilityComponent: FC<Props> = ({ mainIndex, rowIndex, isShow }) => {
  const { isEditMode, initState, dataState } = useRepairOrderQuotesStore();
  const { watch } = useFormContext<RepairOrderQuoteItems>();
  const partNumber = watch(`items.${mainIndex}.parts.${rowIndex}.partNumber`);
  const isDeleted = watch(`items.${mainIndex}.parts.${rowIndex}.isDeleted`);
  const isEnable = !!partNumber;
  const { mutate: updatePartsAvailability, isLoading: isLoadingPartsAvailability } = usePartsAvailabilityMutation();
  const {
    data,
    loading: isLoadingPartInfoFromServiceBo,
    fetchPartInfo
  } = usePartInfo(
    {
      partNo: partNumber?.toString()
    },
    mainIndex,
    rowIndex,
    !isDeleted && isShow,
    (resp) => {
      const wipInfoId = watch(`items.${mainIndex}.parts.${rowIndex}.wipInfoId`);
      const partId = watch(`items.${mainIndex}.parts.${rowIndex}.id`);

      if (wipInfoId && partId) {
        updatePartsAvailability({
          id: wipInfoId,
          requestBody: {
            partId: partId,
            location: resp.location,
            availability: resp.availability,
            retailPriceExlVat: resp.retailPriceExlVat,
            discount: resp.discount
          }
        });
      }
    }
  );

  const handleCheckAvailability = () => {
    if (!partNumber && !initState?.soHeaderId) return;
    fetchPartInfo(
      {
        partNo: partNumber?.toString()
      },
      false
    );
  };

  const currentData = data
    ? data
    : dataState?.length &&
      dataState[mainIndex]?.parts?.length &&
      dataState?.[mainIndex]?.parts?.[rowIndex]?.availability
    ? dataState?.[mainIndex]?.parts?.[rowIndex]?.availability
    : undefined;

  return (
    <div className={styles.listContainer}>
      <div className={styles.header}>
        <div>Availability</div>
        {!isDeleted && isEditMode && (
          <button
            type="button"
            onClick={handleCheckAvailability}
            className="btn btn-primary btn-sm text-nowrap"
            disabled={isLoadingPartInfoFromServiceBo || !isEnable}
          >
            <InlineSvg path="/media/icons/custom/zoom_1.svg" className="svg-icon-2" />
            Check availability
          </button>
        )}
      </div>
      {isLoadingPartInfoFromServiceBo ? (
        <Skeleton count={1} height={'40px'} width={'230px'} style={{ marginBottom: '3px' }} />
      ) : (
        <div className={clsx(styles.divTable, 'w-100')}>
          <div className={clsx(styles.divTableRow)}>
            <div>Location</div>
            <div className={clsx(styles.rowValueBold)}>{currentData?.location ?? '-'}</div>
          </div>

          <div className={clsx(styles.divTableRow)}>
            <div>Availability</div>
            <div className={clsx(styles.rowValueBold)}>{currentData?.availability ?? '-'}</div>
          </div>

          <div className={clsx(styles.divTableRow)}>
            <div>Retail Price ex VAT</div>
            <div className={clsx(styles.rowValueBold)}>{formatCurrencySafe(currentData?.retailPriceExlVat, '-')}</div>
          </div>

          <div className={clsx(styles.divTableRow)}>
            <div>Discount</div>
            <div className={clsx(styles.rowValueBold)}>{currentData?.discount ?? '-'}</div>
          </div>
        </div>
      )}
    </div>
  );
};
